import { gql } from '@apollo/client';

export const DELETE_DATASET_LINK = gql`
  mutation DeleteDatasetLink($id: ID!) {
    datasetLink: deleteDatasetLink(id: $id) {
      id
    }
  }
`;
